import { ACADEMY_WELCOME_URL } from './config';

export default function AcademyWelcomeView() {
  return (
    <div className="h-screen">
      <iframe
        className="w-full h-full"
        src={ACADEMY_WELCOME_URL}
        allow="fullscreen; camera; microphone"
      ></iframe>
    </div>
  );
}
